import styled from "styled-components";

export const Ul = styled.ul`
  width: 100%;
  margin-bottom: 30px
`;
